import { FleekError } from './FleekError';

type Domain = {
  id?: string;
  status?: string;
};

type DomainInPendingStateErrorOptions = {
  domain: Domain;
};

export class DomainInPendingStateError extends FleekError<DomainInPendingStateErrorOptions> {
  public name = 'DomainInPendingStateError';

  toString = () => {
    return 'Domain is in pending state. Please wait and try action again later.';
  };
}
